module.exports = __webpack_public_path__ + "static/img/2.d34ce54.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/13/eng/2.png
// module id = YWUW
// module chunks = 0